import { Button, Col, Form, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
// import { useHistory } from "react-router";
import Swal from "sweetalert2";
import { AbogadoService } from "../../../../_services/abogados.service";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setLoading } from "../../../../redux/Loading/actions";

export const NewAbogado = ({ getAbogados, titulos }) => {
  const dispatch = useDispatch();

  const {
    register,
    handleSubmit,
  } = useForm();

  useEffect(() => {
    register();
  }, []);

  const onSubmit = (newData) => {
    Swal.fire({
      title: "¿Esta seguro de guardar los cambios?",
      icon: "warning",
      showCancelButton: true,
      cancelButtonText: "No",
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si",
      reverseButtons: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        newData.rol = "30";
        dispatch(setLoading(true));

        let response = await AbogadoService.createAbogado(newData);
        
        dispatch(setLoading(false));

        if (response.status === 200) {
          getAbogados();
          Swal.fire(
            "Exito!",
            "Abogado creado exitosamente.",
            "success"
          );
        } else {
          getAbogados();
          Swal.fire(
            "Error!",
            (response.data || "Ocurrio un error, intentelo nuevamente."),
            "error"
          );
        }
      }
    });
  };


  return (
    <div className="abogado-container">
      <div className="abogado-container-form">
        <Form className="abogado-form" onSubmit={handleSubmit(onSubmit)}>
          <Row>
            <Col sm={12} xl={6} md={6} className="mt-3">
              <Form.Label className="text-uppercase">Apellidos</Form.Label>
              <Form.Control
                name="apellido"
                {...register("apellido", { required: "La fecha es requerida." })}
              />
            </Col>
            <Col sm={12} xl={6} md={6} className="mt-3">
              <Form.Label className="text-uppercase">Nombres</Form.Label>
              <Form.Control
                name="nombre"
                {...register("nombre", { required: "La fecha es requerida." })}
              />
            </Col>
          </Row>
          <Row >
            <Col sm={12} xl={6} md={6} className="mt-3">
              <Row>
                <Col className="col-4 pl-0">
                  <Form.Label className="text-uppercase">Documento</Form.Label>
                  <Form.Control
                    as="select"
                    name="tipodni"
                    defaultValue={1}
                    {...register("tipodni")}
                  >
                    <option value={1}>DNI</option>
                  </Form.Control>
                </Col>
                <Col className="col-8 d-flex align-items-end">
                  <Form.Control
                    name="nrodni"
                    {...register("nrodni", { required: "La fecha es requerida." })}
                  />
                </Col>
              </Row>
            </Col>
            <Col sm={12} xl={6} md={6} className="mt-3">
              <Form.Label className="text-uppercase">Dirección</Form.Label>
              <Form.Control
                name="direccion"
                {...register("direccion")}
              />
            </Col>
          </Row>
          <Row>
            <Col sm={12} xl={6} md={6} className="mt-3">
              <Form.Label className="text-uppercase">Telefono</Form.Label>
              <Form.Control
                name="te"
                {...register("te")}
              />
            </Col>
            <Col sm={12} xl={6} md={6} className="mt-3">
              <Form.Label className="text-uppercase">Email</Form.Label>
              <Form.Control
                name="email"
                {...register("email")}
              />
            </Col>
          </Row>
          <Row>
            <Col sm={12} xl={6} md={6} className="mt-3">
              <Form.Label className="text-uppercase">Matricula</Form.Label>
              <Form.Control
                name="matricula"
                {...register("matricula")}
              />
            </Col>
            <Col sm={12} xl={6} md={6} className="mt-3">
              <Form.Label className="text-uppercase">Cuit - Cuil</Form.Label>
              <Form.Control
                name="cuitcuil"
                {...register("cuitcuil")}
              />
            </Col>
          </Row>
          <Row>
            <Col sm={12} xl={6} md={6} className="mt-3">
              <Form.Label className="text-uppercase">Titulo</Form.Label>
              <Form.Control
                as="select"
                name="titulo"
                {...register("titulo")}
              >
                <option value={0}>Seleccionar</option>
                {titulos?.length && titulos.map((e) => {
                  return (
                    <option key={e.id} value={e.id}>{e.titulo}</option>
                  );
                })}
              </Form.Control>
            </Col>
            <Col sm={12} xl={6} md={6} className="mt-3">
              <Form.Label className="text-uppercase">Baja</Form.Label>
              <Form.Control
                as="select"
                name="baja"
                {...register("baja")}
              >
                <option value={0}>No</option>
                <option value={1}>Si</option>
              </Form.Control>
            </Col>
          </Row>
          <Row>
            <Col sm={12} xl={6} md={6} className="mt-3">
              <Form.Label className="text-uppercase">Codigo Externo</Form.Label>
              <Form.Control
                name="codexterno"
                {...register("codexterno", { required: "La fecha es requerida." })}
              />
            </Col>
            <Col sm={12} xl={6} md={6} className="mt-3">
              <Form.Label className="text-uppercase">Horarios</Form.Label>
              <Form.Control
                name="horarios"
                {...register("horarios")}
              />
            </Col>
          </Row>

          <Row className="justify-content-center pt-4">
            <Button
              type="submit"
              style={{ maxWidth: 120 }}
              className="custom-button"
            >
              <span>Cargar</span>
            </Button>
          </Row>
        </Form>
      </div>
    </div>
  );
};

export default NewAbogado;